import React from 'react'
import { css } from '@emotion/core'
import { Paragraph } from '@fs/zion-ui'
import { ThingTrophy, PersonGroup } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { useChineseSurnameInfo } from '../../providers/ChineseSurnameProvider'

const colorBoxCss = (backgroundBoxColor, borderBoxColor) => css`
  background-color: ${backgroundBoxColor};
  border: 4px solid ${borderBoxColor};
  width: 100%;
  margin-top: 30px;
`

const ancientOriginsMapCss = css`
  width: 90%;
  min-height: 150px;
  padding: 2px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
`

const ancientOriginsCss = css`
  flex: 7;
  background-color: white;
  text-align: center;
  padding: 0px 0;
  min-width: 0;
`

const marginCss = css`
  margin: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const factRowCss = css`
  display: flex;
  align-items: center;
  gap: 8px;
`

const FactRow = ({ icon: Icon, value, label, iconColor }) => (
  <div css={marginCss}>
    <div css={factRowCss}>
      <Icon size="sm" color={iconColor} />
      <Paragraph size="lg">
        <strong>{value}</strong>
      </Paragraph>
    </div>
    <div style={{ marginInlineStart: '30px' }}>
      <Paragraph size="xs">{label}</Paragraph>
    </div>
  </div>
)

const ChineseSurnamePopulationAndOriginsPrint = ({ population, surnameRank, originMap, color }) => {
  const { colorValuesMap } = useChineseSurnameInfo()
  const { iconColor, backgroundBoxColor, surnameCircleColor: borderBoxColor } = colorValuesMap[color]
  const [t] = useTranslation()

  return (
    <div css={colorBoxCss(backgroundBoxColor, borderBoxColor)}>
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <div style={{ flex: 5, minWidth: 0, fontSize: '12px' }}>
          <FactRow
            icon={PersonGroup}
            value={population}
            label={t('SurnamePage.surname.totalPopulation', 'Total Population')}
            iconColor={iconColor}
          />
          <FactRow
            icon={ThingTrophy}
            value={surnameRank}
            label={t('SurnamePage.surname.rank', 'Surname Rank')}
            iconColor={iconColor}
          />
        </div>
        <div css={ancientOriginsCss}>
          <div style={{ marginTop: '10px' }}>
            <strong>
              <Paragraph centered size="sm">
                {t('SurnamePage.originMap.caption', 'Ancient Origins')}
              </Paragraph>
            </strong>
          </div>
          <img
            src={originMap}
            alt={t('SurnamePage.originMap.description', 'Ancient Origins Map')}
            css={ancientOriginsMapCss}
          />
        </div>
      </div>
    </div>
  )
}

export default ChineseSurnamePopulationAndOriginsPrint
